import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { RootBlock } from "./RootBlock";
import { defaultData } from "./RootDefaultData";

export const Root: BlockExport = {
  type: "component",
  Block: RootBlock,
  defaultData,
  meta: {
    name: "Root",
    nameI18n: "builder_ui.block_type.root",
    version: 1,
    props: {
      children: {
        name: "Children",
        nameI18n: "builder_ui.prop_type.children",
        prop: "children",
        rejects: [],
        type: "children",
      },
    },
  },
};
